import React, { useMemo } from 'react';
import { useLocale } from 'locale';
import { ProjectNameText, InfoSidePaddingContainer, LastInfoLine } from './styled';
import { getCommercialProjectInfoLineConfig } from 'components/cards/new-layout/components/info-line-config';
import renderLineItem from 'components/labelLineItem';
import { PropertyPrimaryLine, PropertySecondaryLine, TagsWrapper } from 'components/cards/new-layout/styled';
import { SpacingBlock } from 'components/spacing-block';
import ProjectTag from 'components/cards/new-layout/components/ProjectTag';
import { CommercialProjectUniversalCardProps } from 'components/cards/types';

const CommercialProjectCard: React.FC<CommercialProjectUniversalCardProps> = (props) => {
  const {
    hasDiscount,
    isPromoted,
    projectName,
    apartmentType,
    priceRange,
    floorRange,
    id,
  } = props;

  const localeProps = useLocale();
  const { t } = localeProps;

  const name = projectName ? projectName : t('universalCard.projectLabel.defaultName');

  const infoLineConfig = useMemo(() => {
    return getCommercialProjectInfoLineConfig(apartmentType, isPromoted, priceRange, floorRange, localeProps).filter(({ showCondition }) => showCondition);
  }, [ apartmentType, isPromoted, priceRange, localeProps, getCommercialProjectInfoLineConfig ]);

  return (
    <InfoSidePaddingContainer>
      {hasDiscount || isPromoted ? (
        <SpacingBlock mBottom={0.5}>
          <TagsWrapper>
            <ProjectTag id={id} inSearchArea={false} hasDiscount={hasDiscount} isPromoted={isPromoted} />
          </TagsWrapper>
        </SpacingBlock>
      ) : null}
      <ProjectNameText size="small" isPromoted={isPromoted}>
        {name}
      </ProjectNameText>
      <PropertySecondaryLine data-auto="property-address">
        {t('universalCard.project.address', {
          city: props.city || null,
          streetName: props.streetName || null,
          streetNumber: props.streetNumber || null,
          neighborhood: null,
        })}
      </PropertySecondaryLine>
      <LastInfoLine>
        <PropertyPrimaryLine>
          {infoLineConfig.map(renderLineItem)}
        </PropertyPrimaryLine>
      </LastInfoLine>
    </InfoSidePaddingContainer>
  );
};

export default CommercialProjectCard;
